const APPROVED = 1;
const UNDER_CONSTRUCTION = 2;
const PENDING_CORRECTION = 3;
const AWAITING_APPROVAL = 4;

const APPROVAL_FLOW_STATUS_FILTER_OPTIONS = {
  ALL                : null,
  APPROVED           : APPROVED,
  UNDER_CONSTRUCTION : UNDER_CONSTRUCTION,
  PENDING_CORRECTION : PENDING_CORRECTION,
  AWAITING_APPROVAL  : AWAITING_APPROVAL
};

const getApprovalStatus = (course) => {
  return {
    [APPROVED]           : window.$nuxt.$t('classPage.approvalFlow.status.approved'),
    [UNDER_CONSTRUCTION] : window.$nuxt.$t('classPage.approvalFlow.status.underConstruction'),
    [PENDING_CORRECTION] : window.$nuxt.$t('classPage.approvalFlow.status.pendingCorrection'),
    [AWAITING_APPROVAL]  : window.$nuxt.$t('classPage.approvalFlow.status.awaitingApproval')
  }[course.approvalFlowStatusId];

};

module.exports = {
  APPROVED,
  UNDER_CONSTRUCTION,
  PENDING_CORRECTION,
  AWAITING_APPROVAL,
  APPROVAL_FLOW_STATUS_FILTER_OPTIONS,
  getApprovalStatus
};
